import React from 'react'
import './styles/aboutme.css'


const AboutMe = () => {
  return (
    <>
    <div className='aboutme-content'>
    Hi! I am <b>Dhruv Gupta</b> <br/>
    I am a Final year Computer Engineering Student at Thapar Institute.<br/>
    I will be Graduating in June 2025.<br/>
    Hobbies : Cooking, Playing Video Games, Watching Anime.<br/>
    </div>
    </>
  )
}

export default AboutMe